@if (importTypeBasic) {
    <mvs-widget [widgetData]="importTypeBasic"></mvs-widget>
}
